import React from 'react'

const ParseHtml = ({ htmlContent }) => {
  return (
    <div 
      dangerouslySetInnerHTML={{ __html: htmlContent }} 
      style={{textWrap:'stable' , overflowX:'auto'}}
    />
  )
}

export default ParseHtml
